
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';
import ProfilePage from '../pages/profile/page';
import ProtectedRoute from '../components/auth/ProtectedRoute';

// Lazy load components
const Home = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const AboutRajahmundry = lazy(() => import('../pages/about/AboutRajahmundry'));
const AboutCorporation = lazy(() => import('../pages/about/AboutCorporation'));
const ProminentPeople = lazy(() => import('../pages/about/ProminentPeople'));
const History = lazy(() => import('../pages/about/History'));
const Departments = lazy(() => import('../pages/about/Departments'));
const Parks = lazy(() => import('../pages/about/Parks'));
const Sports = lazy(() => import('../pages/about/Sports'));
const AboutPage = lazy(() => import('../pages/about/AboutPage'));
const TourismPage = lazy(() => import('../pages/tourism/page'));
const GetawaysPage = lazy(() => import('../pages/tourism/GetawaysPage'));
const FoodPage = lazy(() => import('../pages/tourism/FoodPage'));
const TransportationPage = lazy(() => import('../pages/tourism/TransportationPage'));
const ProminentPlacesPage = lazy(() => import('../pages/tourism/ProminentPlacesPage'));
const ReligiousTourismPage = lazy(() => import('../pages/tourism/ReligiousTourismPage'));
const PushkaraluPage = lazy(() => import('../pages/pushkaralu/page'));
const CitizenLoginPage = lazy(() => import('../pages/citizen-login/page'));
const CitizenRegisterPage = lazy(() => import('../pages/citizen-register/page'));
const ForgotPasswordPage = lazy(() => import('../pages/forgot-password/page'));
const CitizenDashboardPage = lazy(() => import('../pages/citizen-dashboard/page'));
const CitizenDashboardTwoPage = lazy(() => import('../pages/citizen-dashboard-two/page'));
const GISMapPage = lazy(() => import('../pages/gis-map/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const TendersPage = lazy(() => import('../pages/tenders/page'));
const ActsBylawsPage = lazy(() => import('../pages/acts-bylaws/page'));
const ImportantLinksPage = lazy(() => import('../pages/important-links/page'));
const PressReleasesPage = lazy(() => import('../pages/press-releases/page'));
const PressReleaseGalleryPage = lazy(() => import('../pages/press-release-gallery/page'));
const EventsPage = lazy(() => import('../pages/events/page'));
const CitySanitationPage = lazy(() => import('../pages/city-sanitation/page'));
const StreetVendorsPage = lazy(() => import('../pages/dashboards/StreetVendorsPage'));

// const TestingPage = lazy(() => import('../pages/testing/page'));
// const TestingGetawaysPage = lazy(() => import('../pages/testing_getaways/page'));
// const TestingFoodPage = lazy(() => import('../pages/testing_food/page'));
// const TestingProminentPlacesPage = lazy(() => import('../pages/testing_prmnt_places/page'));
// const TestingReligiousTourismPage = lazy(() => import('../pages/testing_religus_trsm/page'));
const TestingRmcProfilePage = lazy(() => import('../pages/testing_rmc_profile/page'));
const TestingRmcWrdprflePage = lazy(() => import('../pages/testing_rmc_wrdprfle/page'));
const TestingRmcSvmlstPage = lazy(() => import('../pages/testing_rmc_svmlst/page'));
const TestingRmcWhoswhoPage = lazy(() => import('../pages/testing_rmc_whoswho/page'));
// const TestingContacusPage = lazy(() => import('../pages/testing_contacus/page'));
const InfoPage = lazy(() => import('../pages/info/page'));
const AIChatPage = lazy(() => import('../pages/ai-chat/page'));


// Service pages
const PropertyTaxService = lazy(() => import('../pages/services/PropertyTaxService'));
const WaterTaxService = lazy(() => import('../pages/services/WaterTaxService'));
const BirthDeathService = lazy(() => import('../pages/services/BirthDeathService'));
const MarriageCertificateService = lazy(() => import('../pages/services/MarriageCertificateService'));
const TradeLicenseService = lazy(() => import('../pages/services/TradeLicenseService'));
const HallBookingService = lazy(() => import('../pages/services/HallBookingService'));
const ArenaBookingPage = lazy(() => import('../pages/services/ArenaBookingPage'));
const FunctionHallBookingPage = lazy(() => import('../pages/services/FunctionHallBookingPage'));
const GrievancesService = lazy(() => import('../pages/services/GrievancesService'));
const RTIRequestService = lazy(() => import('../pages/services/RTIRequestService'));
const OnlineServices = lazy(() => import('../pages/services/OnlineServices'));
const DashboardsPage = lazy(() => import('../pages/dashboards/page'));

// Citizen Feedback module
const FeedbackPage = lazy(() => import('../pages/feedback/page'));
const AdminFeedbackPage = lazy(() => import('../pages/admin/feedback/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home/>
  },
  {
    path: '/about/rajahmundry',
    element: <AboutRajahmundry />
  },
  {
    path: '/about/history/rajahmundry_profile',
    element: <AboutPage />
  },
  {
    path: '/about/history/rajahmundry_ward_profile',
    element: <AboutPage />
  },
  {
    path: '/about/history/sachavalayam_list',
    element: <AboutPage />
  },
  {
    path: '/about/history/rajahmundry_whoswho',
    element: <AboutPage />
  },
  {
    path: '/about/history/rajahmundry_transportation',
    element: <AboutPage />
  },
  {
    path: '/about/history/rajahmundry_gallery',
    element: <AboutPage />
  },
  {
    path: '/about/history/:chge_hsh_tx?',
    element: <History />
  },
  {
    path: '/about/history',
    element: <History />
  },
  {
    path: '/about/rajahmundry_history',
    element: <History />
  },
  {
    path: '/about/corporation',
    element: <AboutCorporation />
  },
  {
    path: '/about/prominent-people/',
    element: <ProminentPeople />
  },
  {
    path: '/about/prominent-people/:chge_hsh_tx?',
    element: <ProminentPeople />
  },
  {
    path: '/about/prominent_people_in_rajahmundry',
    element: <ProminentPeople />
  },
  {
    path: '/about/departments/',
    element: <Departments />
  },
  {
    path: '/about/departments/:chge_hsh_tx?',
    element: <Departments />
  },
  {
    path: '/about/rmc_departments',
    element: <Departments />
  },
  {
    path: '/about/parks',
    element: <Parks />
  },
  {
    path: '/about/parks/',
    element: <Parks />
  },
  {
    path: '/about/sports',
    element: <Sports />
  },
  {
    path: '/about/sports/',
    element: <Sports />
  },
  {
    path: '/about/rajahmundry_profile',
    element: <AboutPage />
  },
  {
    path: '/about/rajahmundry_ward_profile',
    element: <AboutPage />
  },
  {
    path: '/about/sachavalayam_list',
    element: <AboutPage />
  },
  {
    path: '/about/rajahmundry_whoswho',
    element: <AboutPage />
  },
  {
    path: '/about/rajahmundry_transportation',
    element: <TransportationPage />
  },
  {
    path: '/about/rajahmundry_gallery',
    element: <AboutRajahmundry />
  },
  {
    path: '/tourism',
    element: <TourismPage />
  },
  {
    path: '/tourism/around_rajahmundry_getaways',
    element: <GetawaysPage />
  },
  {
    path: '/tourism/food_in_rajahmundry',
    element: <FoodPage />
  },
  {
    path: '/tourism/prominent_places_rajahmundry',
    element: <ProminentPlacesPage />
  },
  {
    path: '/tourism/religious_tourism_rajahmundry',
    element: <ReligiousTourismPage />
  },
  {
    path: '/tourism/:chge_hsh_tx',
    element: <GetawaysPage />
  },
  {
    path: '/pushkaralu',
    element: <PushkaraluPage />
  },
  {
    path: '/citizen-login',
    element: <CitizenLoginPage />
  },
  {
    path: '/citizen-register',
    element: <CitizenRegisterPage />
  },
  {
    path: '/forgot-password',
    element: <ForgotPasswordPage />
  },
  {
    path: '/citizen-dashboard',
    element: <ProtectedRoute />,
    children: [
      {
        index: true,
        element: <CitizenDashboardPage />
      }
    ]
  },
  {
    path: '/citizen-dashboard-two',
    element: <ProtectedRoute />,
    children: [
      {
        index: true,
        element: <CitizenDashboardTwoPage />
      }
    ]
  },
  {
    path: '/profile',
    element: <ProtectedRoute />,
    children: [
      {
        index: true,
        element: <ProfilePage />
      }
    ]
  },
  {
    path: '/gis-map',
    element: <GISMapPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    // Public feedback — accessible without login
    path: '/feedback',
    element: <FeedbackPage />
  },
  {
    // Admin / Officer feedback management console
    path: '/admin/feedback',
    element: <AdminFeedbackPage />
  },
  {
    path: '/web/contacts/',
    element: <AboutPage />
  },
  {
    path: '/web/contacts/:chge_hsh_tx?',
    element: <AboutPage />
  },
  {
    path: '/resources/tenders',
    element: <TendersPage />
  },
  {
    path: '/notice/act_bylaws',
    element: <ActsBylawsPage />
  },
  {
    path: '/notice/:chge_hsh_tx',
    element: <TendersPage />
  },
  {
    path: '/resources/acts-bylaws',
    element: <ActsBylawsPage />
  },
  {
    path: '/resources/important-links',
    element: <ImportantLinksPage />
  },
  {
    path: '/services/rajahmundry_press_release',
    element: <PressReleasesPage />
  },
  {
    path: '/resources/press-releases',
    element: <PressReleasesPage />
  },
  {
    path: '/resources/press-release-gallery',
    element: <PressReleaseGalleryPage />
  },
  {
    path: '/services/events_list',
    element: <EventsPage />
  },
  {
    path: '/resources/events',
    element: <EventsPage />
  },
  {
    path: '/resources/events_list',
    element: <EventsPage />
  },
  {
    path: '/services/property-tax',
    element: <ProtectedRoute />,
    children: [
      {
        index: true,
        element: <PropertyTaxService />
      }
    ]
  },
  {
    path: '/services/water-tax',
    element: <ProtectedRoute />,
    children: [
      {
        index: true,
        element: <WaterTaxService />
      }
    ]
  },
  {
    path: '/services/birth-death',
    element: <ProtectedRoute />,
    children: [
      {
        index: true,
        element: <BirthDeathService />
      }
    ]
  },
  {
    path: '/services/marriage-certificate',
    element: <ProtectedRoute />,
    children: [
      {
        index: true,
        element: <MarriageCertificateService />
      }
    ]
  },
  {
    path: '/services/trade-license',
    element: <ProtectedRoute />,
    children: [
      {
        index: true,
        element: <TradeLicenseService />
      }
    ]
  },
  {
    path: '/services/hall-booking',
    element: <ProtectedRoute />,
    children: [
      {
        index: true,
        element: <HallBookingService />
      }
    ]
  },
  {
    path: '/arena-booking',
    element: <ProtectedRoute />,
    children: [
      {
        index: true,
        element: <ArenaBookingPage />
      }
    ]
  },
  {
    path: '/function-hall-booking',
    element: <ProtectedRoute />,
    children: [
      {
        index: true,
        element: <FunctionHallBookingPage />
      }
    ]
  },
  {
    path: '/services/rti-request',
    element: <ProtectedRoute />,
    children: [
      {
        index: true,
        element: <RTIRequestService />
      }
    ]
  },
  {
    path: '/services',
    element: <OnlineServices />
  },
  {
    path: '/services/:chge_hsh_tx',
    element: <OnlineServices />
  },
  {
    path: '/grievances',
    element: <ProtectedRoute />,
    children: [
      {
        index: true,
        element: <GrievancesService />
      }
    ]
  },
  {
    path: '/dashboards/grievance',
    element: <DashboardsPage />
  },
  {
    path: '/dashboards/owms',
    element: <CitySanitationPage />
  },
  {
    path: '/dashboards/strtvendors',
    element: <StreetVendorsPage />
  },
  {
    path: '/profile',
    element: <ProfilePage />
  },
    // {
  //   path: '/testing',
  //   element: <TestingPage />
  // },
  // {
  //   path: '/testing_getaways',
  //   element: <TestingGetawaysPage />
  // },
  // {
  //   path: '/testing_food',
  //   element: <TestingFoodPage />
  // },
  // {
  //   path: '/testing_prmnt_places',
  //   element: <TestingProminentPlacesPage />
  // },
  // {
  //   path: '/testing_religus_trsm',
  //   element: <TestingReligiousTourismPage />
  // },
  {
    path: '/testing_rmc_profile',
    element: <TestingRmcProfilePage />
  },
  {
    path: '/testing_rmc_wrdprfle',
    element: <TestingRmcWrdprflePage />
  },
  {
    path: '/testing_rmc_svmlst',
    element: <TestingRmcSvmlstPage />
  },
  {
    path: '/testing_rmc_whoswho',
    element: <TestingRmcWhoswhoPage />
  },
 
  {
    path: '/about/info',
    element: <InfoPage />
  },
  {
    path: '/ai-chat',
    element: <AIChatPage />
  },

  // {
  //   path: '/dashboards/grievance',
  //   element: <DashboardsPage />
  // },
  {
    path: '*',
    element: <Navigate to="/" replace />
  }
];

export default routes;


